import { useState, useCallback } from "react";
import { findStep } from "../utils/funnel/stepper";

export const useStepper = (currentStep, stepper) => {
    const [step, setStep] = useState();
    const current = findStep({ list: stepper, stepName: currentStep });
    const prev = current && current.previous && current.previous.value;
    const next = current &&  current.next && current.next.value;
    const renderStep = useCallback(() => setStep(current.value), [current.value]);
    return [step, prev, next, renderStep, current];
};
